import getTranslation from '@/util/getTranslation';

interface NotFoundPageProps {
  translations: string | undefined;
}

function NotFoundPage({ translations: jsonTranslations }: NotFoundPageProps) {
  const translations: unknown = JSON.parse(jsonTranslations || '{}');

  return (
    <h1 className="sd-heading-lg">
      {getTranslation('PageTitle.PageNotFound', translations)}
    </h1>
  );
}

export default NotFoundPage;
